import { ensureArray } from '~/utils/ensureArray';

/**
 * Toggles the given value in the given input list.
 * If the input is not defined, a new list with the value as single
 * element will be created.
 *
 * @param list The input list to use.
 * @param value The value to toggle.
 */
export function toggleValuesInList<T>(
  list: ReadonlyArray<T> | undefined | null,
  value: T | T[]
): T[] {
  const arrayValue = ensureArray(value);
  if (!list) {
    return arrayValue;
  }

  const newList = list.filter((entry) => !arrayValue.includes(entry));

  arrayValue.forEach((entry) => {
    if (!list.includes(entry)) {
      newList.push(entry);
    }
  });

  return newList;
}
